module.exports = __webpack_public_path__ + "img/BillsAngel.14fa2105.png";